import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import L from "leaflet";
import { API_BASE_URL } from "../../utils/BaseUrl";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.3/images/marker-shadow.png",
});

function ChangeView({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
  }, [center, zoom, map]);
  return null;
}

const NearbyGymsPage = () => {
  const [userPosition, setUserPosition] = useState([15.58445, 108.15515]); // Vị trí mặc định 
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchInput, setSearchInput] = useState("");

  // Lấy gym gần vị trí
  const fetchGyms = async (lat, lng) => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(`${API_BASE_URL}/api/Gym/searchNearby`, {
        latitude: lat,
        longitude: lng,
        radiusKm: 5,
      });
      setGyms(response.data);
    } catch (err) {
      console.error("Lỗi lấy dữ liệu Gym:", err);
      setError("Không thể tải dữ liệu Gym.");
    }
    setLoading(false);
  };

  // Geolocation ban đầu
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords;
          setUserPosition([latitude, longitude]);
          fetchGyms(latitude, longitude);
        },
        () => fetchGyms(userPosition[0], userPosition[1])
      );
    } else {
      fetchGyms(userPosition[0], userPosition[1]);
    }
  }, []);

  // Hàm tìm tọa độ từ địa chỉ
  const geocodeAddress = async (address) => {
    try {
      const response = await axios.get("https://nominatim.openstreetmap.org/search", {
        params: {
          q: address,
          format: "json",
          limit: 1,
        },
      });

      if (response.data.length > 0) {
        const { lat, lon } = response.data[0];
        return [parseFloat(lat), parseFloat(lon)];
      } else {
        throw new Error("Không tìm thấy địa chỉ.");
      }
    } catch (err) {
      throw err;
    }
  };

  // Xử lý submit tìm kiếm
  const handleSearch = async (e) => {
    e.preventDefault();
    if (!searchInput) return;

    setLoading(true);
    try {
      const [lat, lng] = await geocodeAddress(searchInput);
      setUserPosition([lat, lng]);
      await fetchGyms(lat, lng);
    } catch (err) {
      setError("Không thể tìm thấy vị trí này.");
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Tìm Gym Gần Bạn</h1>

      <form onSubmit={handleSearch} style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Nhập địa chỉ (ví dụ: Thanh Khê, Ngũ Hành Sơn)"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          style={{ padding: "8px", width: "300px", marginRight: "10px" }}
        />
        <button type="submit" style={{ padding: "8px 15px" }}>
          Tìm kiếm
        </button>
      </form>

      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}
      {loading && <div>Đang tải dữ liệu...</div>}

      <MapContainer
        center={userPosition}
        zoom={13}
        style={{ height: "400px", width: "100%" }}
        scrollWheelZoom={true}
      >
        <ChangeView center={userPosition} zoom={13} />

        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker position={userPosition}>
          <Popup>Bạn đang ở đây</Popup>
        </Marker>

        {gyms.map((gym) => (
          <Marker key={gym.gymId} position={[gym.latitude, gym.longitude]}>
            <Popup>
              <b>{gym.name}</b>
              <br />
              {gym.address}
              {/* <br />
              Khoảng cách: {gym.distanceKm?.toFixed(2)} km */}
              <br />
              <a href={`/detail-fitness/1`}>Xem chi tiết</a>


            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default NearbyGymsPage;
